import React, { useEffect, useState } from 'react';
import TrophyIcon from 'mdi-react/TrophyIcon';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';
import DisplayCounter from '../../_uiComponents/DisplayCounter';

const p = partial('CompanyListPage');

const CompanyLevelBreakdown = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    Api.club
      .getLevels()
      .then(async (levels) => {
        if (!levels?.length) {
          setRows([]);
          return;
        }
        const counts = await Api.companies.getCompaniesCountForLevels(levels);
        // Keep the club's own level order (drag-and-drop sortable in the
        // Settings tab) instead of alphabetizing - it's a ranked tier list
        // (e.g. Bronze -> Silver -> Gold), not an arbitrary set.
        const levelsWithCount = levels
          .map((level) => ({
            id: level.id,
            label: level.value,
            count: counts?.find((c) => c.value === level.value)?.count ?? 0,
          }))
          .filter((level) => level.count > 0);
        setRows(levelsWithCount);
      })
      .catch(() => undefined);
  }, []);

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="mb-3">
      <h4 className="mb-2">{p('levelBreakdownTitle')}</h4>
      {rows.map((row) => (
        <DisplayCounter
          key={row.id}
          id={`level-${row.id}`}
          small
          color="default"
          title={row.label}
          value={`${row.count}`}
          icon={<TrophyIcon style={{ width: 14 }} />}
        />
      ))}
    </div>
  );
};

export default CompanyLevelBreakdown;
